module.exports = __webpack_public_path__ + "img/password-dark.5849cf11.svg";